import React from 'react';
// import { Jumbotron, Button, Col, Row } from 'reactstrap';
import './facade.css';
// import { Link, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import FacadeHeader from './FacadeHeader/facadeHeader';
import FacadeContent from './FacadeContent/facadeContent';
import Offer from '../Offer/offer';

export default class Facade extends React.Component {
    render() {
        return (
           <div>
               <FacadeHeader/>
              <FacadeContent/>
              <Offer/>
           </div>
        );
    };

}